// `group-[&:hover]` instead of `group-hover`: Tailwind v4 wraps `hover` in `@media (hover: hover)`,
// which a touch-primary 2-in-1 with a mouse fails, so the controls would never show there.
// Class names stay literal per group so the Tailwind scanner sees them.
const REVEAL =
  'tw:opacity-0 tw:pointer-events-none tw:focus-visible:opacity-100 tw:data-popup-open:opacity-100 tw:data-popup-open:pointer-events-auto'

export const FIELD_ROW_CONTROL_REVEAL = `${REVEAL} tw:group-[&:hover]/field-row:opacity-100 tw:group-[&:hover]/field-row:pointer-events-auto`
export const TABLE_ROW_CONTROL_REVEAL = `${REVEAL} tw:group-[&:hover]/table-row:opacity-100 tw:group-[&:hover]/table-row:pointer-events-auto`
export const CONDITIONAL_ROW_CONTROL_REVEAL = `${REVEAL} tw:group-[&:hover]/conditional-row:opacity-100 tw:group-[&:hover]/conditional-row:pointer-events-auto`
